export default __webpack_public_path__ + "static/media/change.ef41b442.svg";